/**
 * * Модель запроса на добавление сотрудников в рабочую область
 */
export default class UpsertNamespaceEmployeeListRequest  {
	/**
	 * * Номер рабочей области
	 */
	NamespaceId!: string;
	/**
	 * * Список сотрудников
	 */
	EmployeeIds!: Array<number>;
	/**
	 * * Удаление администраторов назначенных исполнителями из задач
	 */
	RemoveTaskPerformer: boolean = false;
	/**
	 * * Удаление администраторов назначенных наблюдателями из задач
	 */
	RemoveTaskObserver: boolean = false;
	/**
	 * * Удаление доступов к очередям
	 */
	RemoveQueueTasksAccess: boolean = false;
	constructor(obj?: Partial<UpsertNamespaceEmployeeListRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
